/**
 * @module actions/address
 */
import axios from 'axios'
import { API_URL, SET_ACTIVE_EMPLOYEES, SET_STEP_ASSIGNMENTS } from '../constants'

export function setEmployees (employees) {
  return dispatch => {
    dispatch({
      type: SET_ACTIVE_EMPLOYEES,
      employees
    })
  }
}

/**
 * @description Getting orders data
 * @return {Promise} Axios promise
 */
export function getOrderData (data) {
  let url = API_URL + '/Assign/Get'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Getting orders data
 * @return {Promise} Axios promise
 */
export function getOrderDataNew (data) {
  let url = API_URL + '/Assign/Get'
  return dispatch => {
    return axios.post(url, data).then((res) => {
      dispatch({
        type: SET_STEP_ASSIGNMENTS,
        StepAssignments: res.data.StepAssignments
      })
      return res
    })
  }
}

/**
 * @description Assigns the users
 * @return {Promise} Axios promise
 */
export function assignUsers (data) {
  let url = API_URL + '/Assign/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Getting user assignments
 * @return {Promise} Axios promise
 */
export function getUserAssignments (id) {
  let url = API_URL + '/Assign/GetUserAssignments/' + id
  return dispatch => {
    return axios.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/assign.js